export default __webpack_public_path__ + "static/media/movie-round-b-voter.fc18a3a8.svg";